import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  getUserRequest,
  getUserSuccess,
  getUserFailure,
} from "../reducer/UserReducer";
import { getApi, getApiV2, postApiV2 } from "../../utils/ApiRequest";

function* getUserDetails(action) {
  try {
    const token = localStorage.getItem("access_token");
    const user_id = localStorage.getItem("user_id") || action.payload;
    console.log(user_id)
    const headers = {
      Accept: "application/json",
      contenttype: "application/json",
      token:token
    };
    const response = yield call(postApiV2, "auth/getProfile", action.payload, headers);

    yield put(getUserSuccess(response.data));

  } catch (error) {
    console.error("❌ User fetch error:", error);
    yield put(getUserFailure(error.message || "Something went wrong"));
  }
}


function* UserSaga() {
  yield takeLatest(getUserRequest.type, getUserDetails);
}

export default [UserSaga()];
